const liveShowReducer = (data = [], action) => {	
  if (action.type === 'FETCH_LIVE_EVENT_LIST') {
    return action.payload;
  }
  return data;
};

export default liveShowReducer